module.exports = __webpack_public_path__ + "static/gallery-1-f2c12b85a4811f589e5b277fbe438577.jpg";